/**
 * Wistia Player Controller
 *
 * Handles coordination between multiple `<wistia-player>` web components on a page.
 * When one video starts playing, all other videos are automatically paused.
 * Silently handles pages without any Wistia players.
 *
 * @module wistia-player-controller
 * @see {@link https://docs.wistia.com/docs/wistia-player-web-component} Wistia Player Web Component
 */

/**
 * Pauses all Wistia players except the one with the given media ID.
 *
 * @param {string} currentMediaId - The media-id of the video that should keep playing
 */
function pauseOtherWistiaVideos(currentMediaId) {
  document.querySelectorAll('wistia-player').forEach((player) => {
    if (player.getAttribute('media-id') !== currentMediaId) {
      player.pause();
    }
  });
}

// Listen for play events (capture phase) and pause other videos
document.addEventListener(
  'play',
  (e) => {
    const target = e.target;
    if (target?.tagName === 'WISTIA-PLAYER') {
      pauseOtherWistiaVideos(target.getAttribute('media-id'));
    }
  },
  true,
);
